import { render, staticRenderFns } from "./individualRanking.vue?vue&type=template&id=b4503360&scoped=true&"
import script from "./individualRanking.vue?vue&type=script&lang=js&"
export * from "./individualRanking.vue?vue&type=script&lang=js&"
import style0 from "./individualRanking.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./individualRanking.vue?vue&type=style&index=1&id=b4503360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4503360",
  null
  
)

component.options.__file = "individualRanking.vue"
export default component.exports